export default {
	Slide: 'Puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'Das Puzzle ist offen!',
	'Congratulations!': 'Glückwunsch!',
	'You get it': 'Du bekommst',
	'You get the task done': 'Du erledigst die Aufgabe',

	'Show all blocked': 'Alle blockierten anzeigen',

	Author: 'Autor',
	'Reset filters': 'Filter zurücksetzen',

	Blocked: 'verstopft',
	Unlocked: 'Entsperrt',

	'First month cost': 'Preis für 1 Monat',

	'Block student': 'Schüler blockieren',

	Change: 'Ändern',
	'The student is blocked': 'Der Schüler ist gesperrt',
	'The student is blocked with a new price':
		'Der Student wird mit einem neuen Preis gesperrt',
	'To unlock this student, go to the "Restore" section':
		'Um diesen Schüler freizuschalten, gehen Sie zum Abschnitt „Wiederherstellung“',

	'Before blocking, you can change the price for the student':
		'Vor der Sperrung können Sie den Preis für den Studenten ändern',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'ACHTUNG! Nach dem erneuten Speichern der Aufgabe ist das Puzzle für die Schüler, die diese Aufgabe gelöst haben, geschlossen und sie müssen es erneut lösen.',

	"You cannot do homework in the student's platform":
		'Auf der Schülerplattform können keine Hausaufgaben gemacht werden.',

	'Restore the student ?': 'Der Schüler wiederherstellen ?',
	'Restore the teacher ?': 'Der Lehrer wiederherstellen ?',
	'Restore the franchise ?': 'Das Franchise wiederherstellen ?',

	'Transition to 50': 'Übergang auf 50',
	'Transition to 100': 'Übergang auf 100',

	fifty: 'Übergang auf 50',
	hundred: 'Übergang auf 100',

	Faces: 'Gesichter',

	Heroes: 'Heros',
	Clothes: 'Bekleidung',
	Backgrounds: 'Hintergründe',
	Souvenirs: 'Souvenirs',

	'Coming soon': 'Demnächst',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Wow! Herzlichen Glückwunsch, du hast dieses Produkt erfolgreich gekauft!',
	'You can view all your purchases in the "Purchased" section':
		'Alle deine Einkäufe kannst du im Bereich "Gekaufte" einsehen.',

	'Your savings': 'Deine Ersparnisse',
	'You can spend them on something interesting!':
		'Du kannst sie für etwas Interessantes ausgeben!',

	'A student with this email address already exists':
		'Ein Schüler mit der gleichen E-Mail-Adresse existiert bereits.',

	'User with such email already exists':
		'Ein Benutzer mit der gleichen E-Mail-Adresse existiert bereits.',
	'Year of birth': 'Geburtsjahr',
	Registration: 'Anmeldung',
	'Surname of parents': 'Nachname der Eltern',
	School: 'Schule',
	'Field is required': 'Feld ist erforderlich.',
	'Select age': 'Alter auswählen',
	'No such teacher for this year': 'Dieses Jahr gibt es keinen solchen Lehrer.',
	'User with such phone number already exists':
		'Ein Benutzer mit der gleichen Telefonnummer existiert bereits.',
	'You are successfully registered': 'Sie haben sich erfolgreich registriert!',
	'Max length 20 chars': 'Maximale Länge 20 Zeichen',
	'Після реєстрації вам надійде лист з логіном і паролем':
		'Nach der Registrierung erhalten Sie ein E-Mail mit Ihrem Benutzernamen und Passwort.',

	'INTERNATIONAL SCHOOL': 'INTERNATIONALE SCHULE',
	'Mental Arithmetic': 'Mental Arithmetik',
	'For children aged 5-14.': 'Für Kinder im Alter von 5 bis 14 Jahren.',
	'Sign up for a trial lesson': 'Melden Sie sich für eine Probestunde an!',
	'Parents name': 'Name der Eltern',
	'Childs age': 'Alter des Kindes',
	Country: 'Land',
	'Sign up': 'Melden Sie sich an',

	'Open offer agreement': 'Offene Angebotsvereinbarung',
	'Participate in online Indigo Olympiad':
		'Nehmen Sie an der online Indigo-Olympiade teil',
	Participate: 'Teilnehmen',
	export: 'Export',

	wrong: 'falsch',
	right: 'richtig',
	match: {
		addition: 'ADDITION UND SUBTRAKTION',
		multiply: 'MULTIPLIKATION',
		divide: 'DIVISION',
		abacus_random: 'ABAKUS RANDOM',
		anzan: 'ANZAN',
		negative: 'NEGATIVZAHLEN',
		column: 'SPALTEN',
	},
	timeIsOver: 'Die Zeit ist abgelaufen.',
	timer: 'Timer',
	'Back to Lessons': 'Zurück zur Unterrichtliste',
	'Create Lesson': 'Unterricht erstellen',
	Assign: 'Zuordnen',
	Home: 'Startseite',
	'To cabinet': 'Zum Büro',
	'Create a homework': 'Hausaufgaben erstellen',
	January: 'Januar',
	February: 'Februar',
	March: 'März',
	April: 'April',
	May: 'Mai',
	June: 'Juni',
	July: 'Juli',
	August: 'August',
	'Group nickname': 'Gruppen-Spitzname',
	September: 'September',
	October: 'Oktober',
	November: 'November',
	December: 'Dezember',
	Overall: 'Insgesamt',
	Active: 'Aktiv',
	'Contract number': 'Vertragsnummer',
	'For parents': 'Für Eltern',
	'Choose lessons': 'Lektionen wählen',
	Save: 'Speichern',
	'Students active': 'Aktive Schüler',
	Close: 'Schließen',
	'Change birthday': 'Geburtsdatum ändern',
	Sent: 'Gesendet',
	'Choose date': 'Datum auswählen',
	'Include students': 'Schüler zufügen',
	'Add service': 'Dienst hinzufügen',
	'Create folder': 'Ordner erstellen',
	Answer: 'Antwort',
	Price: 'Preis',
	'Date of creating': 'Erstellungsdatum',
	Month: 'Monat',
	unpaid: 'unbezahlt',
	paid: 'bezahlt',
	'Excluded students': 'Ausgeschlossen Schüler',
	'Selected groups': 'Ausgewählte Gruppen',
	Monday: 'Montag',
	Tuesday: 'Dienstag',
	Wensday: 'Mittwoch',
	Thusday: 'Donnerstag',
	Friday: 'Freitag',
	Saturday: 'Samstag',
	Sunday: 'Sonntag',
	Mo: 'Mo.',
	Tu: 'Di.',
	We: 'Mi.',
	Th: 'Do.',
	Fr: 'Fr.',
	Sa: 'Sa.',
	Su: 'So.',
	End: 'Ende',
	'Add discount': 'Rabatt hinzufügen',
	Edit: 'Bearbeiten',
	'Parent found': 'Elternteil gefunden',
	'Changes saved': 'Änderungen gespeichert',
	'The passwords of the parent and the student should not coincide':
		'Die Passwörter von Eltern und Schülern dürfen nicht identisch sein.',
	'Your region`s price is set to': 'Der Preis Ihrer Region ist festgelegt ',
	'and the holder`s reward is': 'und die Belohnung des Inhabers ',
	'regardless of the set price': 'ist unabhängig vom festgelegten Preis.',
	'The given password is not unique for this email':
		'Das eingegebene Passwort ist für diese E-Mail-Adresse nicht eindeutig.',
	'Enter a valid email address.':
		'Geben Sie bitte eine gültige E-Mail-Adresse ein.',
	'The phone number entered is not valid':
		'Die eingegebene Telefonnummer ist ungültig.',
	Holiday: 'Ferien',
	'Working days': 'Werktage',
	Street: 'Straße',
	'Location name': 'Standortname',
	District: 'Kreis',
	'Mental Arithmetik is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Mental Arithmetik ist eine spezielle japanische Methode des schnellen Kopfrechnens, die die intellektuellen Fähigkeiten und Intelligenz von Kindern im Alter von 5 bis 14 Jahren schnell entwickelt. Der Lernprozess findet auf speziellen japanischen Zähltafel Abakus (Soroban) statt. Mental Arithmetik trainiert gleichzeitig die linke und rechte Gehirnhälfte und verbessert so das visuelle Gedächtnis, die Konzentration der Aufmerksamkeit, die kreative Orientierung, das fantasievolle Denken von Kindern und ihre Tendenz zum schnellen Lesen.',
	'Field required': 'Pflichtfeld',
	'Type of legal activity': 'Art der Rechtstätigkeit',
	'Legal address': 'Juristische Adresse',
	'Registration number': 'Registrierungsnummer',
	'Add Group': 'Gruppe hinzufügen',
	'Add Student': 'Schüler hinzufügen',
	Add: 'Hinzufügen',
	'Add file': 'Datei hinzufügen',
	Signin: 'Einloggen',
	'Bonus days': 'Bonus-Tage',
	'Bonus weeks': 'Bonus-Wochen',
	'Are you sure you want to delete?':
		'Sind Sie sicher, dass Sie es löschen möchten?',
	Delete: 'Löschen',
	Days: 'Tage',
	Confirm: 'Bestätigen',
	Cancel: 'Abbrechen',
	Week: 'Woche',
	Weeks: 'Wochen',
	'Group age name': 'Altersname der Gruppe',
	'Set bonus days': 'Bonus-Tage festlegen',
	'Default language': 'Standardsprache',
	'With english': 'mit Englisch',
	'Without english': 'ohne Englisch',
	'Paid status': 'Zahlungsstatus',
	'Not paid': 'nicht bezahlt',
	Turnover: 'Umsatz',
	Block: 'Sperren',
	Blocked: 'Gesperrte',
	'On holidays': 'In den Ferien',
	Language: 'Sprache',
	Discounts: 'Rabatte',
	Message: 'Benachrichtigungen',
	Subject: 'Thema',
	Homework: 'Hausaufgabe',
	'Homework ': 'Training',
	'Homework on': 'Hausaufgaben an',
	'You need to complete the exercises': 'Führe folgende Aufgaben durch!',
	Homework: 'Hausaufgaben',
	'Invoice for': 'Rechnung zur Zahlung',
	"PJSC CB 'PRIVATBANK' in Kyiv": "JSC CB 'PRIVATBANK', Kyiv",
	Account: 'Account',
	Supplier: 'Anbieter',
	Buyer: 'Käufer',
	'Bank code': 'Bankleitzahl',
	'Type phone number or email':
		'Geben Sie Ihre Telefonnummer oder E-Mail-Adresse ein',
	'Type password': 'Geben Sie das Passwort ein',
	'Forgot password': 'Passwort vergessen',
	'Type your email': 'Geben Sie Ihre E-Mail-Adresse ein',
	Send: 'Senden',
	'Email sent': 'E-Mail gesendet',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Wenn ein Konto mit dieser E-Mail-Adresse existiert, senden wir Ihnen ein E-Mail zur Wiederherstellung des Zugriffs.',
	'Back to the sign in': 'Zurück zur Anmeldung',
	'Password or login is not correct':
		'Das Passwort oder der Login sind nicht korrekt.',
	'Password recovery': 'Passwortwiederherstellung',
	'Type your new password here': 'Geben Sie Ihr neues Passwort ein',
	'Set new password': 'Neues Passwort festlegen',
	'Learn more': 'Erfahren Sie mehr',
	'About Us': 'Über uns',
	Company: 'Unternehmen',
	Jobs: 'Jobs',
	Press: 'Presse',
	'Terms of Use': 'AGB',
	'Privacy Policy': 'Datenschutzrichtlinie',
	'Need help?': 'Benötigen Sie Hilfe?',
	'Contact us': 'Kontaktieren Sie uns',
	'Become franchise': 'Werden Sie Franchise',
	'Select language': 'Sprache auswählen',
	English: 'Englisch',
	Russian: 'Russisch',
	Azerbaijani: 'Aserbaidschanisch',
	Ukrainian: 'Ukrainisch',
	Polish: 'Polnisch',
	Management: 'Verwaltung',
	'Master Franchise': 'Master-Franchisenehmer',
	Franchise: 'Franchise',
	Teachers: 'Trainer',
	Groups: 'Gruppen',
	Students: 'Schüler',
	Student: 'Schüler',
	Parents: 'Eltern',
	Profile: 'Profil',
	'My profile': 'Mein Profil',
	Finance: 'Finanzen',
	Reports: 'Berichte',
	Report: 'Bericht',
	Upload: 'Hochladen',
	List: 'Liste',
	Payments: 'Zahlungen',
	Documents: 'Unterlagen',
	Lessons: 'Trainings',
	Materials: 'Materialien',
	Shop: 'Shop',
	Statistics: 'Statistiken',
	Settings: 'Einstellungen',
	Pages: 'Seiten',
	Logout: 'Abmelden',
	Dashboard: 'Mein Konto',
	'Access denied': 'Zugriff abgelehnt',
	Create: 'Erstellen',
	New: 'Neue',
	Download: 'Herunterladen',
	Status: 'Zustand',
	'Payment Date': 'Zahlungsdatum',
	'Payment Amount': 'Zahlungsbetrag',
	'Start time': 'Startzeit',
	'Group age': 'Gruppenalter',
	Junior: 'Kindergartenalter',
	Average: 'Jüngeres Schulalter',
	Class: 'Klasse',
	Older: 'Sekundarschulalter',
	Region: 'Region',
	Group: 'Gruppe',
	Person: 'Person',
	Finances: 'Finanzen',
	Actions: 'Anzahl der Aktionen',
	'Send invoice': 'Rechnung senden',
	'Download invoice': 'Rechnung herunterladen',
	'Send email': 'E-Mail senden',
	'Create Student': 'Schüler erstellen',
	'The beginning of holidays': 'Beginn der Ferien',
	'Start of study': 'Studienbeginn',
	'Group name': 'Gruppenname',
	'Group address': 'Gruppenadresse',
	'Group teacher': 'Gruppentrainer',
	'Group students': 'Gruppenschüler',
	'Group statistics': 'Gruppenstatistik',
	Search: 'Suche',
	'General information': 'Allgemeine Informationen',
	'Phone number': 'Telefonnummer',
	'First name': 'Vorname',
	Surname: 'Nachname',
	'Last name': 'Nachname',
	'Date of birth': 'Geburtsdatum',
	Password: 'Passwort',
	'Additional information': 'Weitere Informationen',
	'Id code': 'ID-Code',
	Passport: 'Pass',
	'Without email newsletter': 'Keine E-Mail-Benachrichtigungen',
	'With email newsletter': 'Mit E-Mail-Benachrichtigungen',
	'Financial information': 'Finanzinformation',
	Royalty: 'Lizenzgebühren',
	'PR contribution': 'PR-Gebühren',
	Currency: 'Währung',
	Comment: 'Bemerkungen',
	Paid: 'Bezahlt',
	Invoices: 'Rechnung',
	Bills: 'Rechnungen',
	Acts: 'Unterlagen',
	Scan: 'Scan',
	Level: 'Niveau',
	'Action with numbers': 'Anzahl der Aktionen',
	'Action with number': 'Anzahl der Aktionen',
	'Number of expressions': 'Anzahl der Beispiele',
	'Number of expression': 'Anzahl der Beispiele',
	'Imaginary abacus': 'Imaginärer Abakus',
	'Period report': 'Berichtszeitraum',
	City: 'Stadt',
	'Full name franchise': 'Vor- und Nachnamen des Franchise',
	'Сost of education': 'Abonnementpreis',
	'Turnover franchise': 'Franchise-Umsatz',
	'Discount sum': 'Rabattbetrag',
	Proprietor: 'Inhaber/in',
	'Additional products and services': 'Weitere Produkte und Services',
	'Full name student': 'Vor- und Nachnamen des Schülers',
	'Period of study': 'Studiendauer',
	'Bonus-days': 'Bonus-Tage',
	'Amount of days': 'Anzahl der Tage',
	'Total days': 'Tage insgesamt',
	'Language of instruction': 'Trainingssprache',
	Teacher: 'Trainer',
	Discount: 'Rabatt',
	Remuneration: 'Vergütung',
	Goods: 'Produkte',
	'Date of creation': 'Erstellungsdatum',
	'Date of payment': 'Zahlungsdatum',
	'Goods (works, services)': 'Produkte (Werke, Dienstleistungen)',
	Quantity: 'Quantität',
	Units: 'Einheiten',
	Amount: 'Gesamt',
	Sum: 'Summe',
	'Sum Sub': 'Fast & Furious',
	Financial: 'Finanziell',
	Additional: 'Zusätzlich',
	General: 'Allgemein',
	Total: 'Gesamt',
	Save: 'Speichern',
	'Including with': 'Einschließlich',
	'Training materials': 'Trainingsmaterialien',
	'Learning contract': 'Trainingsvertrag',
	Games: 'Spiele',
	'NUMBER OF 11 TO 120': 'ZAHLEN VON 11 BIS 120',
	Complexity: 'Komplexität',
	Start: 'Starten',
	'Speedy numbers': 'Fast & Furious',
	Anzan: 'Anzan',
	'Abacus is random': 'Abakus Random',
	Multiplication: 'Multiplikation',
	Division: 'Division',
	Abacus: 'Abakus',

	'Multiplying by 20': 'Multiplikation bis 20',
	Squared: 'Quadratzahlen',
	'Division to 20': 'Division bis 20',
	Speed: 'Geschwindigkeit',
	Repeat: 'Wiederholungen',
	'Game type': 'Spielart',
	'Digit type': 'Art von Zahlen',
	Digit: 'Zahl',
	Time: 'Zeit',
	Oral: 'Imaginär',
	Second: 'Sekunden',
	'Calculation method': 'Rechenmethode',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Nur negative Zahlen, beginnend mit 99, 999, 9999 usw., je nach Schwierigkeit des Beispiels: -9, -2, -3, -1...',
	'Only subtraction': 'Nur Subtraktion',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Nur positive Zahlen, die mit 0 beginnen. z.B.: +1, +4, +6, +9, +5 ...',
	'Only add': 'Nur Addition',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Die Zahlen werden nach dem Zufallsprinzip gezogen, beginnend mit 0. z.B.: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Zufallszahlen',
	'CHOOSE COMPLEXITY:': 'Schwierigkeit auswählen:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'Anzahl der Aktionen mit Zahlen',
	FAMILY: 'FAMILIE',
	'BIG FRIENDS': 'GROßE FREUNDE',
	'LITTLE FRIENDS': 'KLEINE FREUNDE',
	'JUST FRIENDS': 'EINFECH FREUNDE',
	'big friends': 'große Freunde',
	'small friends': 'kleine Freunde',
	elementary: 'einfach Freunde',
	family: 'Familie',
	Sound: 'Ton',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Glückwunsch! Du hast es geschafft!',
	'RIGHT. ANSWER:': 'RICHTIG. ANTWORT:',
	CORRECT: 'RICHTIG',
	'NOT CORRECT': 'FALSCH',
	'Try again': 'Versuch es noch einmal!',
	expression: 'BEISPIEL',
	next: 'NÄCHSTE',
	Next: 'NÄCHSTE',
	Previous: 'VORHERIGE',
	Loading: 'Wird geladen!',
	back: 'zurück',
	Back: 'zurück',
	ANSWER: 'ANTWORT',
	Lesson: 'Lektion',
	'History statistics': 'Geschichte der Statistik',
	Open: 'Öffnen',
	'Game statistics per day': 'Spielstatistik pro Tag',
	'Total played games': 'Insgesamt gespielte Spiele',
	'Total correct answers': 'Insgesamt richtige Antworten',
	'Total played:': 'Insgesamt gespielt:',
	Feedback: 'Feedback',
	'Leave a review': 'Hinterlassen Sie eine Bewertung!',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Teilen Sie uns Ihr Feedback oder Ihre Wünsche mit und wir werden diese bei der Ausarbeitung des Produktes auf jeden Fall berücksichtigen.',
	'Payment history': 'Zahlungsverlauf',
	'Payment status': 'Zahlungsstatus',
	Pay: 'Zahnel',
	Payer: 'Empfänger',
	'Getting a discount': 'Rabatt erhalten',
	Training: 'Training',
	Tasks: 'Aufgabe',

	'Current task': 'Aktuelle Aufgabe',
	'Only task': 'Einzige Aufgabe',
	'Next tasks': 'Folgende Aufgaben',
	'Online abacus': 'Online-Abakus',
	'Base 50/100': 'Basis 50/100',
	multiply_base: 'Basis 50/100',
	divided: 'geteilt',
	'Do not show this instruction again':
		'Zeigen Sie diese Anweisungen nicht erneut an!',
	'Instructions for homework': 'Anweisungen für Hausaufgaben.',
	divider: 'Teiler',
	'Multiplication table': 'Multiplikationstabelle',
	Restore: 'Wiederherstellen',
	Left: 'Es sind geblieben',
	'Restore Hierarchy': 'Hierarchie wiederherstellen',
	total: 'Gesamt',
	active: 'aktiv',
	blocked: 'gesperrt',
	pageError: {
		'403': 'Der Zugriff wird verweigert.',
		'404': 'Diese Seite konnte nicht gefunden werden. Versuchen Sie es erneut.',
		'500': 'Der Server antwortet nicht. Versuchen Sie es erneut.',
	},
	error: {
		'Account deactivated': 'Ihr Account wurde deaktiviert.',
	},
	modalNewVersion: {
		text:
			'Sie verwenden eine veraltete Version der Website.\nDas Update ist ab sofort verfügbar.',
		btn: 'Updaten',
	},
	games: {
		negativeNumbers: 'Negativzahlen',

		pause: 'Pause',
		resume: 'Fortsetzen',

		columns: {
			name: 'Spalten',
			users: 'Spieleranzahl',
			user: 'Spieler',
			userNames: 'Spielernamen',
		},
	},
	'Indigo-dollars': 'Indigo-Dollars',
	Balance: 'Saldo',

	modalIndigoDollars: {
		submit: 'Senden',
		cancel: 'Abbrechen',
		title: 'Indigo-Dollars',
		balance: 'Aktueller Saldo',
		amount: 'Quantität',
		reason: 'Begründung',
	},

	modalAddNotification: {
		title: 'Benachrichtigung hinzufügen',
		submit: 'Senden',
		cancel: 'Abbrechen',
		empty: 'Keine Benachrichtigungen',
	},

	modalTransactionsHistory: {
		title: 'Zahlungsverlauf',
		type: {
			withdraw: 'abbuchen',
			deposit: 'aufladen',
		},
		empty: 'Die Zahlungsliste ist leer.',
	},

	modalCopyHomework: {
		title: 'Hausaufgaben kopieren',
		label:
			'Wählen Sie das Datum aus, an dem Sie die Hausaufgaben kopieren möchten.',
		submit: 'Kopieren',
		cancel: 'Abbrechen',
	},

	reportsPage: {
		history: {
			title: 'Änderungsgeschichte',
			empty: 'Die Liste ist leer.',
			table: {
				date: 'Änderungsdatum',
				field_name: 'Aktion',
				old_value: 'Alter Wert',
				new_value: 'Neuer Wert',
				user: 'Es wurde bei dem Benutzer geändert',
			},
		},
	},

	pageShop: {
		title: 'Shop',
		description:
			'Im Shop kannst du verschiedene Produkte kaufen, um das optische Erscheinungsbild deines persönlichen Kontos zu verbessern.',

		tabs: {
			all: 'Alle Produkte',
			purchased: 'Kaufen',
		},

		item: {
			off_all: 'alles deaktivieren',

			status: {
				AVAILABLE: 'VERFÜGBAR',
				DEPRECATED: 'ABWESEND',
				COMING_SOON: 'DEMNÄCHST',
			},
			is_activated: 'Ausgewählt',
			set_active: 'Aktiv setzen',
			unset_active: 'Deaktivieren',
			preview: 'Vorschau',
			is_free: 'Kostenlos',
			buy: 'Kaufen',
			bought: 'Gekauft',
			purchased: 'Gekaufte',
		},
		empty: {
			all: 'Keine Upgrades verfügbar.',
			purchased: 'Keine Upgrades gekauft.',
		},

		toast: {
			error: 'Es ist ein Fehler aufgetreten.',
			notEnoughMoney: 'Unzureichende Indigo-Dollar.',
			itemBought: 'Verbesserung ist gekauft.',
			itemActivated: 'Verbesserung ist aktiviert.',
			itemDeactivated: 'Verbesserung ist deaktiviert.',
		},
		confirmPurchase: {
			title: 'Kauf bestätigen',
			message: 'Möchten Sie diesen Artikel wirklich kaufen?',
			confirm: 'Ja, kaufen',
			cancel: 'Abbrechen',
		},
	},

	demo: {
		title: 'Kostenlose Demo-Lektion',
		tutorial: {
			title: 'Anweisungen',
			text:
				'Wir begrüßen Sie zur online Demo-Lektion zum Thema Kopfrechnen bei Indigo Mental.\n Indigo Mental ist die beste internationale Schule für das Kopfrechnen der Welt. Die langjährige Erfahrung des Unternehmens und die Erfolge vieler Schüler auf der ganzen Welt bei Olympiaden beweisen, dass diese Technik effektiv, einzigartig und funktioniert. Viele Eltern sind schon lange von der Methode überzeugt, freuen sich über die Erfolge ihrer Kinder nicht nur im Rechnen, sondern auch in anderen Wissenschaften, Musik, Sport und stellen einen großen Sprung in den intellektuellen Fähigkeiten ihres Kindes fest.\nMental Arithmetik ist eine spezielle japanische Methode des schnellen Kopfrechnens, die die intellektuellen Fähigkeiten und die Intelligenz eines Kindes schnell entwickelt. Der Lernprozess findet auf speziellen japanischen Zähltafel Abakus (Soroban) statt. Mental Arithmetik trainiert gleichzeitig die linke und rechte Gehirnhälfte und verbessert so das visuelle Gedächtnis, die Konzentration der Aufmerksamkeit, die kreative Orientierung und das fantasievolle Denken bei Kindern.\nFangen wir schon mal an, die Mental Arithmetik zu erlernen. Klicken Sie dazu im folgenden Video auf die Schaltfläche „Play“, hören Sie es sich an und wiederholen Sie den Vorgang.',
		},
	},

	disableStudent: {
		btn: 'Schüler deaktivieren',
		list: 'Schüler ohne Deaktivierungsdatum',
		modal: {
			title: 'Schüler deaktivieren',
			description: 'Sie sind im Begriff, einen Schüler zu deaktivieren.',
			fieldLabel: 'Monat auswählen',
			btnSubmit: 'Deaktivieren',
			btnCancel: 'Abbrechen',
		},
	},
}
